import { connect } from "react-redux";
import MyAccountLinks from "./MyAccountLinks";

import {
  getDefaultLanguage,
  getCountryCode,
  getStoreCode,
  getKeyStoreDataversion,
  getDefaultStoreUrl
} from "../../../state/modules/regionalStore";

function mapStateToProps(state) {
  return {
    storeCode: getStoreCode(state),
    lang: getDefaultLanguage(state),
    countryCode: getCountryCode(state),
    keyStoreDataversion: getKeyStoreDataversion(state),
    defaultStoreUrl: getDefaultStoreUrl(state)
  };
}

export default connect(mapStateToProps)(MyAccountLinks);



// WEBPACK FOOTER //
// ./template/components/Footer/MyAccountLinks/index.js